import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { PurchaseReceiptReport } from './purchase-receipt-report.model';

@Injectable({
  providedIn: 'root'
})
export class PurchaseReceiptReportService {

  private readonly purchaseReceiptReportUrl = 'reports/';

  constructor(private readonly http: HttpClient) {
  }

  getPurchaseReceiptReport(reportId: number) {
    const url = `${this.purchaseReceiptReportUrl}${reportId}/`;

    return this.http.get(url).pipe(
      map(response => response ? PurchaseReceiptReport.fromJSON(response) : null)
    );
  }

  deletePurchaseReceiptReport(reportId: number) {
    const url = `${this.purchaseReceiptReportUrl}${reportId}/`;

    return this.http.delete(url);
  }

  downloadPurchaseReceiptPdf(reportId: number) {
    return this.http
      .get(
        `${this.purchaseReceiptReportUrl}${reportId}/`,
        { headers: { 'Accept': 'application/pdf' }, responseType: 'blob' })
      .subscribe(
        response => {
          const fileName = 'purchase-receipt.pdf';
          if(window.navigator.msSaveOrOpenBlob) { // IE/Edge support (https://stackoverflow.com/questions/24007073/open-links-made-by-createobjecturl-in-ie11)
            const fileData = [response];
            const blobObject = new Blob(fileData);
            window.navigator.msSaveOrOpenBlob(blobObject, fileName);
          } else {
            const url = window.URL.createObjectURL(response);
            const anchorElement = document.createElement('a');
            document.body.appendChild(anchorElement);
            anchorElement.setAttribute('style', 'display: none');
            anchorElement.href = url;
            anchorElement.download = fileName;
            anchorElement.click();
            window.URL.revokeObjectURL(url);
            anchorElement.remove();
          }
        });
  }

}
